import { Component, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';
import { FeedProduct } from '@vestiaire/api-sdk-angular';
import { FeedProfile } from '@vestiaire/api-sdk-angular';

export interface ISeeProduct {
  product: FeedProduct;
  position: number;
}

export interface ILikeProduct {
  product: FeedProduct;
  position: number;
  isLiked: boolean;
}

@Component({
  selector: 'vc-feed-card-new-ins',
  templateUrl: './feed-card-new-ins.component.html',
  styleUrls: ['./feed-card-new-ins.component.scss', '../products-card.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FeedCardNewInsComponent {
  @Input() activities: FeedProduct[];
  @Input() profile: FeedProfile;
  @Input() totalCardActivities: number;
  @Input() likedItems: string[];

  @Output() seeProduct = new EventEmitter<ISeeProduct>();
  @Output() likeProduct = new EventEmitter<ILikeProduct>();
  @Output() seeMoreProduct = new EventEmitter<string>();
}
